/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpaceModalContent
 */
export interface SpaceModalContent {
    /**
     * Modal title
     * @type {string}
     * @memberof SpaceModalContent
     */
    title: string;
    /**
     * Modal description/body text
     * @type {string}
     * @memberof SpaceModalContent
     */
    description: string;
    /**
     * Optional image URL for modal
     * @type {string}
     * @memberof SpaceModalContent
     */
    imageUrl?: string;
    /**
     * Call-to-action button text
     * @type {string}
     * @memberof SpaceModalContent
     */
    ctaText: string;
}

/**
 * Check if a given object implements the SpaceModalContent interface.
 */
export function instanceOfSpaceModalContent(value: object): value is SpaceModalContent {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('ctaText' in value) || value['ctaText'] === undefined) return false;
    return true;
}

export function SpaceModalContentFromJSON(json: any): SpaceModalContent {
    return SpaceModalContentFromJSONTyped(json, false);
}

export function SpaceModalContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpaceModalContent {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'ctaText': json['ctaText'],
    };
}

export function SpaceModalContentToJSON(json: any): SpaceModalContent {
    return SpaceModalContentToJSONTyped(json, false);
}

export function SpaceModalContentToJSONTyped(value?: SpaceModalContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'imageUrl': value['imageUrl'],
        'ctaText': value['ctaText'],
    };
}

